import { render } from "./AddNewEvent.vue?vue&type=template&id=64861212"
import script from "./AddNewEvent.vue?vue&type=script&lang=js"
export * from "./AddNewEvent.vue?vue&type=script&lang=js"

import "./AddNewEvent.vue?vue&type=style&index=0&id=64861212&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__